import { Spinner } from "@nextui-org/react";
import React from "react";
import { ThirdPartyVendorLayout } from "..";

const AssessmentLoadingScreen: React.FC = () => {
  return (
    <ThirdPartyVendorLayout>
      <div className="w-full h-full flex items-center justify-center bg-white">
        <div className="flex flex-col items-center gap-4 max-w-4xl px-4">
          {/* Spinner */}
          <div className="mb-8">
            <Spinner size="lg" className="w-12 h-12" />
          </div>
          
          {/* Text content matching Figma specs */}
          <div 
            className="flex flex-col items-center gap-4"
            style={{
              width: '100%',
              maxWidth: '1321px',
            }}
          >
            {/* Main heading */}
            <div 
              className="text-center text-[#171717]"
              style={{
                fontFamily: 'Inter',
                fontStyle: 'normal',
                fontWeight: 400,
                fontSize: '18px',
                lineHeight: '28px',
                maxWidth: '879px',
              }}
            >
              Assessing your responses for follow-up questions. Please check back for updates.
            </div>
            
            {/* Subtext */}
            <div 
              className="text-center text-[#71717A]"
              style={{
                fontFamily: 'Inter',
                fontStyle: 'normal',
                fontWeight: 400,
                fontSize: '14px',
                lineHeight: '20px'
              }}
            >
              This process might take up to 60 minutes. Thank you for your patience!
            </div>
          </div>
        </div>
      </div>
    </ThirdPartyVendorLayout>
  );
};

export default AssessmentLoadingScreen;